<template>
  <div class="work-box">
    <div @click="back" class="header">
      <i class="iconfont">&#xe604;</i>
    </div>
    <vue-data-loading :loading="loading" :completed="completed" :listens="['infinite-scroll']" :init-scroll="true" @infinite-scroll="infiniteScroll">
      <div class="goods-list">
        <div class="goods-item" v-for="(item, index) in goodsList" :key="index">
          <div class="goods-item-icon" @click="checkRadio(index)">
            <i class="iconfont already-check" v-if="item.check">&#xe697;</i>
            <i class="iconfont no-check" v-else>&#xe695;</i>
          </div>
          <div class="item-img">
            <img :src="item.imgUrl ? url + item.imgUrl : defaultimg" />
          </div>
          <div class="item-info">
            <div class="item-info-title">{{item.title}}</div>
            <div class="item-info-content">
              <div class="item-info-price">￥{{item.price}}</div>
              <input class="item-info-count" @keydown="handleInput" type="number" v-model="item.count" />
            </div>
          </div>
        </div>
      </div>
    </vue-data-loading>
    <div class="btn-box">
      <div class="btn-save" @click="goSave">确认选择</div>
    </div>
  </div>
</template>

<script>
import VueDataLoading from 'vue-data-loading'
import url from '@/common/common.js'
export default {
  name: 'TransferItem',
  components: {
    VueDataLoading // 注册VueDataLoading组件
  },
  data () {
    return {
      alist: [],
      loading: false,
      completed: false,
      num: 1,
      size: 8,
      goodsList: [],
      userName: '',
      url,
      defaultimg: '/static/img/defaultimg.jpg' // 默认图片
    }
  },
  methods: {
    back () {
      this.$router.go(-1) // 返回上一层
    },
    fetchData () {
      this.loading = true
      this.getinfo()
    },
    infiniteScroll () {
      this.fetchData()
      this.num++
    },
    getinfo () {
      if (this.userName === '') {
        alert('未选择店铺')
        return
      }
      this.axios.get('/ApiGoodList/GetListByUID', {
        params: {
          uname: this.userName,
          num: this.num, // 页码
          size: this.size
        }
      })
        .then(this.getinfoSucc)
        .catch(this.getinfoFail)
    },
    getinfoSucc (res) {
      res = res.data
      if (res.ret && res.data) {
        const data = res.data
        var newList = JSON.parse(data.goodsList)
        newList = newList.map(item => {
          item.check = false
          item.count = 1
          return item
        })
        if (this.num === 0) {
          this.completed = true
          this.loading = false
        } else {
          this.goodsList = this.goodsList.concat(newList)
          if (newList.length < this.size) {
            this.completed = true
          }
          this.loading = false
        }
      }
    },
    getinfoFail () {
      alert('获取数据失败')
    },
    handleInput (e) {
      // 通过正则过滤小数点后两位
      e.target.value = (e.target.value.replace(/[^\d]/g, '')) || null
    },
    checkRadio (index) {
      let check = this.goodsList[index].check
      this.goodsList[index].check = !check
    },
    goSave () {
      let tempArry = []
      for (let i = 0; i < this.goodsList.length; i++) {
        let item = this.goodsList[i]
        if (item.check) {
          let count = parseInt(item.count)
          count = isNaN(count) ? 1 : count
          let tempItem = {
            id: item.id,
            img: item.imgUrl,
            title: item.title,
            count: count
          }
          tempArry.push(tempItem)
        }
      }
      console.log(tempArry)
      let info = {
        account: this.userName,
        itemList: tempArry
      }
      this.$router.push({
        path: '/transfer',
        query: {
          clientInfo: info
        }
      })
    }
  },
  created () {
    this.userName = this.$route.query.userName
    // this.getinfo()
  }
}
</script>

<style scoped>
  .work-box{
    position: relative;
    padding-bottom: 70px;
  }
  .goods-item{
    display: flex;
    align-items: center;
    padding: 10px 20px;
    border-bottom: 5px solid #f8f8f8;
  }
  .goods-item-icon{
    flex-shrink: 0;
    padding: 0 10px;
  }
  .goods-item-icon .iconfont{
    color: #FF0000;
    font-size: 16px;
  }
  .item-img{
    flex-shrink: 0;
    width: 80px;
    height: 80px;
    border-radius: 5px;
    overflow: hidden;
  }
  .item-img img{
    width: 100%;
    height: 100%;
  }
  .item-info{
    flex-grow: 1;
    padding: 0 10px;
  }
  .item-info .item-info-title{
    margin-bottom: 10px;
    font-size: 14px;
    color: #000000;
    font-weight: 500;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
  .item-info-content{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .item-info-price{
    color: #FF0000;
  }
  .item-info-count{
    padding: 1px 0;
    width: 40%;
    text-align: center;
    border: 1px solid #c5c5c5;
  }
  .header{ padding: 10px 15px; padding-bottom: 5px; border-bottom: 1px solid #f2f2f2;}
  .header a{ text-decoration: none; color: #333;}
  .header .iconfont{ font-size: 25px;}
  .btn-box{
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    padding: 20px 40px;
    box-sizing: border-box;
    background: #ffffff;
  }
  .btn-box .btn-save{
    height: 34px;
    line-height: 34px;
    background: #FF0000;
    color: #ffffff;
    text-align: center;
    font-size: 14px;
    border-radius: 34px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/transfer_item/TransferItem.vue